import axios from "axios";
import { API_ROOT } from "../config";

// FastAPI backend unificado
const api = axios.create({
    baseURL: `${API_ROOT}/api/v1/store`
})

// Adjuntar token de cliente si existe
api.interceptors.request.use((config) => {
    const token = localStorage.getItem('customerToken')
    if (token) {
        config.headers.Authorization = `Bearer ${token}`
    }
    return config
})

export default api